import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import Splide from '@splidejs/splide';
export var carouselBehavior = function carouselBehavior() {
  Alpine.data('carouselBehavior', function () {
    var visibleItemCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 6;
    var itemGap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '2rem';
    return {
      carousel: undefined,
      carouselIsShowing: false,
      perPage: visibleItemCount,
      gap: itemGap,
      init: function init() {
        // When modal appears, refresh carousel to ensure its on the correct slide.
        this.watch('carouselIsShowing');
        this.initSlider();
      },
      initSlider: function initSlider() {
        // Create new splide instance for carousel if one hasn't been created already.
        var hasParentCarousel = false;
        if (this.$store.carouselStatus && this.$store.carouselStatus.parentCarousel) {
          hasParentCarousel = true;
        } else {
          hasParentCarousel = false;
        }
        if (this.carousel === undefined && !hasParentCarousel) {
          this.carousel = new Splide(this.$el, {
            rewind: true,
            pagination: true,
            arrows: false,
            type: 'loop',
            drag: 'free',
            perPage: 3,
            mediaQuery: 'min',
            focus: 'center',
            gap: '0.5rem',
            breakpoints: {
              768: {
                perPage: this.perPage,
                gap: this.gap
              }
            }
          });
          this.carousel.mount();
        }
      },
      watch: function watch(property) {
        var _this = this;
        this.$watch(property, function (newValue) {
          if (newValue === true) {
            setTimeout(function () {
              _this.refreshCarousel();
            }, 50);
          }
        });
      },
      refreshCarousel: function refreshCarousel() {
        if (this.carousel !== undefined) {
          this.carousel.refresh();
        }
      }
    };
  });
};